<template>
    <Card>
        <div>
            <div class="sousuo" style="width: 100%">
                <div style="width: 350px" class="yl-flex flex_between">
                    <Input placeholder="搜索名称" v-model="name" style="width: 250px">
                        <i-button slot="append" icon="ios-search"></i-button>
                    </Input>
                    <Button class='ivu-btn-circle' type="primary" @click="getList">搜索</Button>
                </div>
            </div>
            <div class="multiple">
                <div class="child-div">时间区间</div>
                <RadioGroup v-model="timePeriod">
                    <Radio label="0"><span>不限</span></Radio>
                    <Radio label="1"><span>今日</span></Radio>
                    <Radio label="2"><span>昨日</span></Radio>
                    <Radio label="3"><span>本周</span></Radio>
                    <Radio label="4"><span>上周</span></Radio>
                    <Radio label="5"><span>本月</span></Radio>
                    <Radio label="6"><span>上月</span></Radio>
                    <Radio label="7"><span>自定义</span></Radio>
                    <DatePicker v-show="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
                                type="daterange"
                                placeholder="选择日期" style="width: 200px"></DatePicker>

                </RadioGroup>
            </div>

            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">
                    <template slot-scope="{ row }" slot="status">
                        <div :style="{'color':row.status_color}" >{{row.status_name}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="pic">
                        <div style="color: #00A0FF" @click="checkPic" :data-pic="row.ext_info.pic">查看凭证</div>
                    </template>
                    <template slot-scope="{ row }" slot="operation">
                        <div style="display: inline-block;color: #00A0FF" @click="pass" :data-id="row.id">通过</div>
                        <div style="display: inline-block;color: red; padding-left: 10px" @click="refuse" :data-id="row.id">拒绝</div>
                    </template>
                </Table>
            </div>
            <div class="pager">
                <Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small" show-elevator/>
            </div>
        </div>
        <Modal
                v-model="modal"
                title="填写拒绝原因"
                @on-cancel="() => {modal = false}">
            <div class="multiple">
                <div class="child-div inline-block">填写原因</div>
                <Input type="textarea" style="width: 300px" v-model="remark"></Input>
            </div>
            <div slot="footer">
                <Button type="primary" @click="saveRefuse()">确定</Button>
            </div>
        </Modal>
    </Card>
</template>
<script>
    import {getOtherList,saveExpenditureStatus} from "../../api/finance";
    import {mapGetters} from "vuex";

    export default {
        name: "otherManagement",
        components: {},

        data() {
            return {
                modal: false,
                page: 1,
                count: 0,
                name: '',
                timePeriod: '0',
                remark: '',
                refuseId: 0,
                timePeriodDate: [],
                datas: [
                ],
                columns: [
                    {
                        "title": "支出人",
                        "key": "name"
                    },
                    {
                        "title": "支出事项",
                        "key": "matter"
                    },
                    {
                        "title": "支出日期",
                        "key": "expenditure_at"
                    },
                    {
                        "title": "支出金额",
                        "key": "money"
                    },
                    {
                        "title": "审批状态",
                        "slot": "status"
                    },
                    {
                        "title": "备注",
                        "key": "remark"
                    },
                    {
                        "title": "凭证",
                        "slot": "pic"
                    },
                    {
                        "title": "操作",
                        "slot": "operation"
                    }
                ]
            }
        },
        computed: {
            ...mapGetters(['token', 'userInfo'])
        },
        mounted() {
            this.loadData();
            this.getList();
        },
        methods: {
            timePeriodDateChange(e) {
                this.timePeriodDate = e
            },
            checkPic(e) {
                let pic = e.currentTarget.dataset.pic;
                window.open(pic)
            },
            pass(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                that.throttle( async function () {
                    let data = {
                        token: that.token,
                        id: id,
                        status: 1,
                    };
                    let res = await saveExpenditureStatus(that, data);
                    if (res.code == 1) {
                        that.getList();
                    }
                }, 500)
            },
            saveRefuse() {
                let that = this;
                that.throttle( async function () {
                    let data = {
                        token: that.token,
                        id: that.refuseId,
                        remark: that.remark,
                        status: -2,
                    };
                    let res = await saveExpenditureStatus(that, data);
                    if (res.code == 1) {
                        that.remark = '';
                        that.modal = false;
                        that.getList();
                    }
                }, 500)
            },
            refuse(e) {
                this.refuseId = e.currentTarget.dataset.id;
                this.modal = true;
            },
            async loadData() {
            },
            changePage(e) {
                this.page = e;
                this.getList();
            },
            async getList() {
                let that = this;
                let data = {
                    page: that.page,
                    token: that.token,
                    status: -1,
                    timePeriod: that.timePeriod,
                    timePeriodDate: that.timePeriodDate,
                    name: that.name,
                };
                let res = await getOtherList(that, data);
                if (res.code == 1) {
                    that.datas = res.data.list;
                    that.count = res.data.count;
                }
            },
        },


    }
</script>
<style scoped lang="less">

    .yellow_btn {
        color: #F8BD66;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }


    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .inline-block{
        display: inline-block;
    }
</style>
